import React from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Catalogue from './screens/Catalogue';
import Develop from './screens/Develop';
import Gallery from './screens/Gallery';
import About from './screens/About';
import FrontendBundle from './screens/FrontendBundle';
import BackendBundle from './screens/BackendBundle';
import DataScience from './screens/DataScience';
import ReactBundle from './screens/ReactBundle';
import FullStackJs from './screens/FullstackJs';
import FullStackWeb from './screens/FullStackWeb';
import Java from './screens/Java';
import Android from './screens/Android';
import ReactNative from './screens/ReactNative';
import UIDesign from './screens/UIDesign';
import PhotoShop from './screens/Photoshop';
import Cyber from './screens/Cyber';
import Contact from './screens/Contact';

function App(){
  return (
    <Router>
      <div>
      <Switch>
      <Route exact path="/catalogue" component={Catalogue} />
      <Route path="/catalogue/develop" exact component={Develop} />
      <Route path="/catalogue/gallery" exact component={Gallery} />
      <Route path="/catalogue/about" exact component={About} />
      <Route path="/catalogue/frontend" exact component={FrontendBundle} />
      <Route path="/catalogue/backend" exact component={BackendBundle} />
      <Route path="/catalogue/data-science" exact component={DataScience} />
      <Route path="/catalogue/react-training" exact component={ReactBundle} />
      <Route path="/catalogue/fullstack-js" exact component={FullStackJs} />
      <Route path="/catalogue/fullstack-web-development" exact component={FullStackWeb} />
      <Route path="/catalogue/java-training" exact component={Java} />
      <Route path="/catalogue/android-development-training" exact component={Android} />
      <Route path="/catalogue/cross-platform-app-development-training" exact component={ReactNative} />
      <Route path="/catalogue/ui-ux-design" exact component={UIDesign} />
      <Route path="/catalogue/photoshop" exact component={PhotoShop} />
      <Route path="/catalogue/ethical-hacking" exact component={Cyber} />
      <Route path="/catalogue/contact" exact component={Contact} />
      </Switch>
      </div>
      </Router>
  )
}

export default App;